const stopLoaderBar = (tableId) => {
    $$(tableId).hideProgress();
};

export default stopLoaderBar;
